// WineTech multi-tag taxonomy (Sprint 41 — Feb 2026)
// All categories are MULTI-select. Each tag string includes its emoji prefix and is stored as-is.

export const WT_TAG_CATEGORIES = [
  {
    key: "maturity",
    label: "Maturité de la solution",
    short: "Maturité",
    badge: "bg-violet-50 text-violet-700 border-violet-200",
    options: [
      "💡 Concept / Prototype",
      "🚀 Early Stage",
      "📈 Solution éprouvée",
      "🌍 Déployée à grande échelle",
    ],
  },
  {
    key: "value_chain",
    label: "Chaîne de valeur vin",
    short: "Chaîne de valeur",
    badge: "bg-emerald-50 text-emerald-700 border-emerald-200",
    options: [
      // 🍇 Production
      "🍇 Viticulture",
      "🍇 Œnologie",
      "🍇 Matériel",
      // 🏭 Élaboration
      "🏭 Vinification",
      "🏭 Qualité",
      "🏭 Traçabilité",
      // 📦 Distribution
      "📦 Logistique",
      "📦 Supply Chain",
      "📦 Export",
      // 🛒 Commercialisation
      "🛒 Marketing",
      "🛒 Vente",
      "🛒 E-commerce",
      // 🍷 Consommateur
      "🍷 Oenotourisme",
      "🍷 Expérience client",
      "🍷 Fidélisation",
    ],
  },
  {
    key: "innovation",
    label: "Type d'innovation",
    short: "Innovation",
    badge: "bg-sky-50 text-sky-700 border-sky-200",
    options: [
      "🤖 IA",
      "📊 Data",
      "📡 IoT / Capteurs",
      "🦾 Robotique",
      "🛍️ Marketplace",
      "💳 Fintech",
      "🧬 Biotech",
      "🌱 Climate Tech",
      "📦 Packaging",
      "⛓️ Blockchain",
      "☁️ SaaS",
      "🔧 Hardware",
    ],
  },
  {
    key: "business_model",
    label: "Modèle économique",
    short: "Modèle éco.",
    badge: "bg-amber-50 text-amber-800 border-amber-200",
    options: [
      "☁️ SaaS",
      "📜 Licence",
      "🛍️ Marketplace",
      "🎓 Conseil",
      "🛠️ Service managé",
      "🔧 Hardware",
      "🔌 Hardware + Software",
      "💰 Commission",
      "🆓 Freemium",
    ],
  },
  {
    key: "markets",
    label: "Pays / marché couvert",
    short: "Marchés",
    badge: "bg-indigo-50 text-indigo-700 border-indigo-200",
    options: [
      "🇫🇷 France",
      "🇪🇸 Espagne",
      "🇮🇹 Italie",
      "🇩🇪 Allemagne",
      "🇺🇸 États-Unis",
      "🇬🇧 Royaume-Uni",
      "🇦🇺 Australie",
      "🌍 Monde",
    ],
  },
  {
    key: "benefit",
    label: "Bénéfice principal",
    short: "Bénéfice",
    badge: "bg-rose-50 text-rose-700 border-rose-200",
    options: [
      "💰 Augmenter les ventes",
      "⏱️ Gagner du temps",
      "📉 Réduire les coûts",
      "🌱 Réduire l'impact environnemental",
      "📊 Mieux piloter son activité",
      "🌍 Développer l'export",
      "🤝 Mieux connaître ses clients",
    ],
  },
  {
    key: "transformation",
    label: "Niveau de transformation",
    short: "Transformation",
    badge: "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200",
    options: [
      "⚙️ Optimiser",
      "🎯 Simplifier",
      "🤖 Automatiser",
      "✨ Nouveau modèle",
    ],
  },
];

// Mongo field names where these tags are persisted (on Company doc & on event_profile sub-object).
export const WT_TAG_FIELDS = WT_TAG_CATEGORIES.map((c) => `tag_${c.key}`);

export const WT_TAG_CATEGORY_BY_KEY = Object.fromEntries(
  WT_TAG_CATEGORIES.map((c) => [c.key, c]),
);
